<template>

<div class="printbox printtablevisitbooking">
  <div class="boxA" :style="{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px'}">
  <button class="printBtn btnA" @click="print">列印</button>
  <!-- <button class="printBtn btnA" @click="exportTable">匯出</button> -->
  </div>
  <button class="printBtn btnB" @click="$emit('close')"><iconClose/></button>
  <div id="printTeamTable" :style="{
    backgroundColor: '#FFFFFF',
    padding: '0',
    width: '866px',
    height: 'fit-content',
    borderBottom: '1px solid #DCDCDC',
    boxSizing: 'border-box',
    fontFamily: 'Noto Sans TC',
    color: '#737373',
    transform: 'scale(0.76)',
    overflowY: 'auto'
  }">
  <div ref="printhtml" id="printTeam2" :style="{
    backgroundColor: '#FFFFFF',
    width: '866px',
    height: '1225px',
    boxSizing: 'border-box',
    fontFamily: 'Noto Sans TC'
  }">
  <div :style="{
    width: '838px',
    height: '1193px',
    padding: '21px 13px',
  }">
  <div class="title">{{dtrg}}</div>
  <div class="summary">
    <div class="summarydiv">一般 : {{total1?total1:'-'}}</div>
    <div class="summarydiv">優待 : {{total2?total2:'-'}}</div>
    <div class="summarydiv">優惠 : {{total3?total3:'-'}}</div>
    <div class="summarydiv">免費 : {{total4?total4:'-'}}</div>
    <div class="summarydiv">總人數 : {{total}}</div>
  </div>
  <div :style="{width: '827px'}" class="pageBox">
    <div
     v-for="(item, i) in teams" :key="`team-${i}`" class="pageBreakInsideAvoid" :class="item.status==='已取消'?'canceled': ''">
      <div>
        <span class="wrap">{{item.status}}</span>
      </div>
      <div>
        <span>{{moment(item.visitDate).format('gg-MM-DD')}}</span>
        <span>{{item.visitTime}}</span>
      </div>
      <div>
        <div>
        <span>{{item.agencyID}}</span>
        <div class="wrap">{{item.agency?item.agency.name.trim():'-'}}<br>{{item.groupName?item.groupName.trim():'-'}}</div>
        </div>
      </div>
      <div>
        <span>預約人 : {{item.orderer}}</span>
        <span>電話 : {{item.ordererTel}}</span>
        <hr>
        <span>領隊 : {{item.leader}}</span>
        <span>電話 : {{item.leaderTel}}</span>
      </div>
      <div>
        <span class="center" v-if="(!item.remit5code||item.remit5code==='')&&(!item.remitName||item.remitName==='')" :style="{fontSize: '13px'}">無付訂</span>
        <template v-else>
          <span>{{moment(item.remitTime).format('gg-MM-DD HH:mm')}}</span>
          <span>戶名 : {{item.remitName}}</span>
          <span>後五碼 : {{item.remit5code}}</span>
          <span>匯款金額 : {{item.remitAmount}}</span>
        </template>
      </div>
      <div>
        <span class="center">業務</span>
        <span class="center">{{item.salesman&&item.salesman.name}}</span>
      </div>
      <div :style="{borderRight:'0.5px solid #898989'}">
        <span v-if="!item.guideNeeds">
          導覽 <span class="hl l-6" v-html="item.guideNeeds===null?'<br>待確認':'X'"></span>
        </span>
        <span v-else>
        <span>導覽 <span class="hl">{{item.docentCount}}</span> 名</span>
        <br>
        <span>{{item.guideRemark}}</span>
        </span>
      </div>
      <div>
        <span>總人數 : <span class="hl">{{item.reserveNum}}</span></span>
        <div class="flexspan">
          <span :style="{display: 'inline-block', width: '60px'}">一般 : {{item.ticketCategory.ticket_1?item.ticketCategory.ticket_1:'-'}}</span>
          <span>優待 : {{item.ticketCategory.ticket_2?item.ticketCategory.ticket_2:'-'}}</span>
          <span :style="{display: 'inline-block', width: '60px'}">優惠 : {{item.ticketCategory.ticket_3?item.ticketCategory.ticket_3:'-'}}</span>
          <span>免費 : {{item.ticketCategory.ticket_4?item.ticketCategory.ticket_4:'-'}}</span>
        </div>
      </div>
    </div>
  </div>
  </div>
  </div>
  </div>
</div>
</template>

<script>
import printjs from 'print-js'
import XLSX from 'xlsx'
import iconClose from '../../SVG/iconClose'
export default {
  props: ['teams', 'daterange', 'range'],
  components: {
    iconClose
  },
  computed: {
    total () {
      return this.teams.filter(e => e.status !== '已取消').map(e => (e.reserveNum ? parseInt(e.reserveNum) : 0)).filter(a => a).reduce((a, b) => a + b, 0)
    },
    total1 () {
      return this.teams.filter(e => e.status !== '已取消').map(e => (e.ticketCategory.ticket_1 ? parseInt(e.ticketCategory.ticket_1) : 0)).reduce((a, b) => a + b, 0)
    },
    total2 () {
      return this.teams.filter(e => e.status !== '已取消').map(e => (e.ticketCategory.ticket_2 ? parseInt(e.ticketCategory.ticket_2) : 0)).reduce((a, b) => a + b, 0)
    },
    total3 () {
      return this.teams.filter(e => e.status !== '已取消').map(e => (e.ticketCategory.ticket_3 ? parseInt(e.ticketCategory.ticket_3) : 0)).reduce((a, b) => a + b, 0)
    },
    total4 () {
      return this.teams.filter(e => e.status !== '已取消').map(e => (e.ticketCategory.ticket_4 ? parseInt(e.ticketCategory.ticket_4) : 0)).reduce((a, b) => a + b, 0)
    },
    dtrg () {
      switch (this.daterange) {
        case '今日預約':
          return this.moment().format('YYYY-MM-DD') + ' 團體預約參觀'
        case '明日預約':
          return this.moment().add(1, 'day').format('YYYY-MM-DD') + ' 團體預約參觀'
        case '全部預約':
          return this.moment().format('YYYY-MM-DD') + ' ~ 團體預約參觀'
        case '自訂時間':
          return `${this.moment(this.range.start).format('YYYY-MM-DD')} ~ ${this.moment(this.range.end).format('YYYY-MM-DD')} 團體預約參觀`
        default:
          return '團體預約參觀'
      }
    }
  },
  methods: {
    async exportTable () {
      const table = document.getElementById('teamTable')
      const name = this.dtrg.replaceAll(' ', '_')
      await XLSX.utils.table_to_sheet(table, {
        dateNF: 's',
        sheet: name,
        raw: true
      })
      // const jsondata = await XLSX.utils.sheet_to_json(sheet)
      // console.log('sheet', sheet)
      const workbook = await XLSX.utils.table_to_book(table, { dateNF: 's', sheet: name, raw: true })
      XLSX.writeFile(workbook, `${name}.xlsx`)
    },
    print () {
      // const css = '@page {size: portrait;width: 210mm;height: 297mm;margin: 0 10px;padding: 0;.pageBreakInsideAvoid{page-break-inside: avoid;} }'
      // const head = document.head
      // if (document.getElementById('printord')) {
      //   const style = document.getElementById('printord')
      //   if (style.styleSheet) {
      //     style.styleSheet.cssText = css
      //   } else {
      //     style.appendChild(document.createTextNode(css))
      //   }
      // } else {
      //   const style = document.createElement('style')
      //   style.id = 'printord'
      //   style.type = 'text/css'
      //   style.media = 'print'
      //   if (style.styleSheet) {
      //     style.styleSheet.cssText = css
      //   } else {
      //     style.appendChild(document.createTextNode(css))
      //   }
      //   head.appendChild(style)
      // }

      printjs({
        printable: 'printTeam2',
        type: 'html',
        style: `

        @page{size: A4 portrait;}
        body{
          -webkit-print-color-adjust: exact;
          -moz-print-color-adjust: exact;
          -ms-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        *{box-sizing: border-box;font-family:'Noto Sans TC';color: #5E5E5E;}
        .summary{display:flex;border:0.5px solid #CACACA;align-items:center;height: 37px;
        justify-content:space-between;padding:0 136px;font-size:10px;color:#5E5E5E;margin-top:11px;}
        .summarydiv{min-width: 90px;white-space:nowrap;}
        .title{font-size:18px;letter-spacing:.15em;text-align:center;line-height:40px;height: 40px;}
        .pageBreakInsideAvoid{
          page-break-inside: avoid;
          border:0.5px solid #898989;
          margin-top:10px;
          display: flex;
          height: fit-content;
          min-height: 195px;
          border-radius: 3px;
        }
        .pageBreakInsideAvoid.canceled {
          background-color: #D9D9D9;
        }
        .pageBreakInsideAvoid.canceled hr { background: #FFFFFF; border-color: #FFFFFF; }
        .pageBox{display:flex;flex-direction:column;gap:10px;}
        .pageBreakInsideAvoid>div{
          min-height: 195px;
          height: fit-content;
          font-size:10px;
          border-right:0.5px solid #898989;
          display:flex;
          flex-direction:column;
          align-items:flex-start;
          justify-content:center;
          padding-inline:5px;
        }
        span:not(.wrap){white-space:nowrap;}
        span.wrap{word-break: break-all;height: fit-content;min-width: 100%;}
        div.wrap{word-break: break-all;min-height: fit-content;min-width: 127px;line-height: 1.5em;}
        .pageBreakInsideAvoid>div>hr{width: 100%;}
        .hl {font-size: 20px;font-weight: 900;}
        .l-6{margin-left: .6em;}
        .pageBreakInsideAvoid>div>span.center{margin-inline: auto;}
        .pageBreakInsideAvoid>div:nth-child(1){font-size:14px;min-width:1.2em;max-width:1.7em;width:fit-content;text-align:center;padding:0;}
        .pageBreakInsideAvoid>div:nth-child(2){font-size:10px;min-width:73px;max-width:73px;text-align:start;}
        .pageBreakInsideAvoid>div:nth-child(2)>span:nth-child(2){font-size:16px;font-weight:900;}
        .pageBreakInsideAvoid>div:nth-child(3){font-size:10px;min-width:137px;max-width:137px;text-align:start;}
        .pageBreakInsideAvoid>div:nth-child(4){font-size:10px;min-width:149px;max-width:149px;text-align:start;}
        .pageBreakInsideAvoid>div:nth-child(5){font-size:10px;min-width:124px;max-width:124px;text-align:start;}
        .pageBreakInsideAvoid>div:nth-child(6){font-size:10px;min-width:55px;max-width:55px;padding:0;}
        .pageBreakInsideAvoid>div:nth-child(6)>span{padding:0;}
        .pageBreakInsideAvoid>div:nth-child(8){font-size:10px;min-width:129px;max-width:129px;}
        .flexspan {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap:wrap;
        }
        .pageBreakInsideAvoid>div:last-child{
          border-right:none;
        }
        `
      })
      // this.$print(this.$refs.printhtml)
    }
  }
}
</script>
<style lang="scss">
.printtablevisitbooking {

        @page{size: A4 portrait;}
        *{box-sizing: border-box;font-family:'Noto Sans TC';color: #5E5E5E;}
        .summary{display:flex;border:0.5px solid #CACACA;align-items:center;height: 37px;
        justify-content:space-between;padding:0 136px;font-size:14px;color:#5E5E5E;margin-top:11px;}
        .summarydiv{min-width: 90px;white-space:nowrap;}
        .title{font-size:18px;letter-spacing:.15em;text-align:center;line-height:40px;height: 40px;}
        .pageBreakInsideAvoid{
          page-break-inside: avoid;
          border:0.5px solid #898989;
          margin-top:10px;
          display: flex;
          height: fit-content;
          min-height: 135px;
          border-radius: 3px;
        }
        .pageBreakInsideAvoid.canceled {
          background-color: #D9D9D9;
        }
        .pageBreakInsideAvoid.canceled hr { background: #FFFFFF; border-color: #FFFFFF; }
        .pageBox{display:flex;flex-direction:column;gap:10px;}
        .pageBreakInsideAvoid>div{
          font-size:14px;
          border-right:0.5px solid #898989;
          display:flex;
          flex-direction:column;
          align-items:flex-start;
          justify-content:center;
          padding-inline:5px;
        }
        span:not(.wrap){white-space:nowrap;}
        span.wrap{word-break: break-all;height: fit-content;}
        div.wrap{word-break: break-all;height: fit-content;min-width: 137px;margin-block: auto;line-height: 1.5em;}
        .pageBreakInsideAvoid>div>hr{width: 100%;}
        .hl {font-size: 20px;font-weight: 900;}
        .l-6{margin-left: .6em;}
        .pageBreakInsideAvoid>div>span.center{margin-inline: auto;}
        .pageBreakInsideAvoid>div:nth-child(1){font-size:14px;min-width:1.2em;max-width:1.7em;width:fit-content;text-align:center;padding:0;}
        .pageBreakInsideAvoid>div:nth-child(2){font-size:14px;min-width:83px;max-width:83px;text-align:start;}
        .pageBreakInsideAvoid>div:nth-child(2)>span:nth-child(2){font-size:16px;font-weight:900;}
        .pageBreakInsideAvoid>div:nth-child(3){font-size:14px;min-width:137px;max-width:137px;text-align:start;}
        .pageBreakInsideAvoid>div:nth-child(4){font-size:14px;min-width:149px;max-width:149px;text-align:start;}
        .pageBreakInsideAvoid>div:nth-child(5){font-size:14px;min-width:124px;max-width:124px;text-align:start;}
        .pageBreakInsideAvoid>div:nth-child(6){font-size:14px;min-width:65px;max-width:65px;text-align:center;padding:0;}
        .pageBreakInsideAvoid>div:nth-child(8){font-size:14px;min-width:129px;max-width:129px;}
        .flexspan {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap:wrap;
        }
        .pageBreakInsideAvoid>div:last-child{
          border-right:none;
        }
}
</style>

<style lang="scss" scoped>

@page {
  size: portrait;
  width: 210mm;
  height: 297mm;
  margin: 0 10px;
  padding: 0;
}
@media print {
  @page {
    size: portrait;
    width: 210mm;
    height: 297mm;
    margin: 0 10px;
    padding: 0;
  }
  .pagebreak { page-break-inside: auto; }
  #printTeam2 {
    -webkit-text-size-adjust: none;
    transform: scale(1.34);
    transform-origin: top left;
    div {
      -webkit-print-color-adjust: exact;
    }
  }
}
#printTeam2 {
  -webkit-text-size-adjust: none;
}
.boxA {
  position: absolute;
  bottom: 60px;
  z-index: 201;
  height: 35px;
  left: 0;
  right: 0;
}
.printBtn {
  border: none;
  &.btnA {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    &::before {
      content: '';
      display: inline-block;
      width: 25px;
      height: 22px;
      background-image: url(/print.svg);
    }
    width: 100px;
    height: 35px;
    background-color: var(--color-checked);
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    border-radius: 20px;
  }
  &.btnB {
    position: absolute;
    top: calc(50vh - 460px);
    left: calc(50vw + 247px);
    z-index: 201;
    background-color: transparent;
  }
}
#printTeamTable {
  position: relative;
  box-shadow: 4px 2px 15px rgba(0, 0, 0, 0.25);
}
.printbox {
  // overflow-y: auto;
  background: rgba(94, 94, 94, 0.3);
  // background-color: ;
position: fixed;
top: 0;
left: 70px;
right: 0;
bottom: 0;
display: flex;
align-items: center;
justify-content: center;
z-index: 200;
backdrop-filter: blur(8px);
// left: calc(50vw - 421px);
}
</style>
